import type { GenerateAppSchemaParameters, SchemaDefinition } from '@sap/ux-specification-types';
import type { Definition } from 'typescript-json-schema';

/**
 * Generates an app-specific schema from the generic schema.
 * Generic types are replaced by data from the app-specific annotations.
 *
 * @param {GenerateAppSchemaParameters} generateParameters - list of API input parameters
 * @param {object} appSchema - generic JSON schema of the application page (app.json)
 */
export function generateAppSchemaV4(generateParameters: GenerateAppSchemaParameters, appSchema: Definition): void {
    const settingDefinition = appSchema.definitions?.AppSettings as Definition;
    const sideEffectsEventsInteractionType = settingDefinition.properties
        ?.sideEffectsEventsInteractionType as SchemaDefinition;
    // Hide settings that are defined in schema, but required annotation is missing
    const entityTypes = generateParameters.serviceAVT?.entityTypes ?? [];
    const hasSideEffectsEvents = entityTypes.find((entityType) => {
        const common = entityType.annotations.Common ?? {};
        for (const term in common) {
            // Check for side effects with or withour qualifiers
            if (term.startsWith('SideEffects')) {
                const sourceEvents = common?.[term]?.SourceEvents;
                return sourceEvents !== undefined && sourceEvents.length > 0;
            }
        }
    });
    if (!hasSideEffectsEvents) {
        sideEffectsEventsInteractionType.hidden = true;
    }
}
